<template>
   <el-container class="content" style="display: block;">
    <div>
      <img :src="require('@/assets/image/logo.png')"   height="auto" width="150px" @click="toPage()" style="position: absolute;top:1%;z-index: 5;left: 10%;z-index: 1008;opacity: 0.8;">
    </div>

    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;"  :style="{'width':screenWidth+'px','height':screenHeight+'px'}">
      <video width="100%" height="98%" ref="videoPlayer" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo">
        <source :src="video_url" type="video/mp4">

      </video>

    </div>

    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        name:this.$route.query.name,
        video_url:'https://video.universepower.cn/yuzhouzhimi/'+this.$route.query.name+'.mp4',
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight


      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.open()




    },

	methods:{

    open(){
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play();
        }
      });
    },


		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }

/* //全屏按钮 */
/* video::-webkit-media-controls-fullscreen-button { */
/*    display: none;
} */
/* //播放按钮 */
/* video::-webkit-media-controls-play-button {
    display: none;
} */
/* //进度条 */
video::-webkit-media-controls-timeline {
    display: none;
}
/* //观看的当前时间 */
video::-webkit-media-controls-current-time-display{
    display: none;
}
/* //剩余时间 */
video::-webkit-media-controls-time-remaining-display {
    display: none;
}
/* //音量按钮 */
video::-webkit-media-controls-mute-button {
    display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
}
/* //音量的控制条 */
video::-webkit-media-controls-volume-slider {
    display: none;
}
/* 所有控件 */
video::-webkit-media-controls-enclosure{
    display: none;
}


</style>



// WEBPACK FOOTER //
// src/components/main/video.vue